// ─── SINGLE SOURCE OF TRUTH FOR $KBULL MARKET DATA ────────────────────────────
// PRE-LAUNCH: $KBULL has not launched — every value is 0 (no estimates, no demo data).
// Roadmap bars, hero ticker and the $10M unlock all derive from: progress = currentMarketCap / milestone
// LAUNCH DAY: set TOKEN_DATA_SOURCE = "api" (backend /api/token → real Solana data) and publish tokenAddress.

export const TOKEN_STATUS = { LAUNCH_PENDING: "LAUNCH_PENDING", LIVE: "LIVE" };

export const TOKEN_DATA_SOURCE = "config"; // "config" | "api"

export const TOKEN_DATA = {
  status: TOKEN_STATUS.LAUNCH_PENDING,
  currentMarketCap: 0,
  currentPrice: 0,
  holders: 0,
  volume24h: 0,
  // The published address belongs to /buy; homepage pre-launch statistics stay unchanged.
  tokenAddress: null,
};

export const STATUS_LABEL = { LAUNCH_PENDING: "LAUNCH PENDING", LIVE: "LIVE" };
export const AWAITING_LAUNCH = "AWAITING LAUNCH";
